import React, { useState } from 'react';
import {
  Row,
  Col,
  Button,
  Card,
  Skeleton,
} from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { UpdateUser } from '../../../actions';
import { CustomAlertModal } from '../../../shared';
import { GlobalApiErrorHandler } from '../../../shared/helpers';
import { MsgBox, FileUpload, acceptedFiles, acceptedImageFiles } from '../../../shared/custom-ant-d'
import { reqPostUploadFile, reqPostDownloadFile, reqPostUpdateCandidateDocs } from '../../../axios/api';

const acceptedFilesArray = acceptedFiles.accept.replace(/\s/g, '').split(",");
acceptedFilesArray.push(...acceptedImageFiles);

const fileTypes = {
  resume: 'resume',
  coverletter: 'coverletter',
  birthcertificate: 'birthcertificate',
  cxc: 'cxc',
  coc: 'coc',
  nationalId: 'nationalId',
  hsDiploma: 'hsDiploma',
  policerecord: 'policerecord'
}
export const DocumentUpload = (props) => {
  const Auth = useSelector(state => state.Auth);
  const dispatch = useDispatch();
  const [isFileModalVisible, setIsFileModalVisible] = useState(false);
  const [fileToDelete, setFileToDelete] = useState("");
  const [fileDeleteMessage, setFileDeleteMessage] = useState("");

  const [isCoverLetterDownloading, setIsCoverLetterDownloading] = useState(false);
  const [coverLetterUpload, setCoverLetterUpload] = useState(false);

  const [resumeUpload, setResumeUpload] = useState(false);
  const [isResumeDownloading, setIsResumeDownloading] = useState(false);

  const [birthCertificateUpload, setBirthcertificateUpload] = useState(false);
  const [isBirthCertificateDownloading, setIsBirthCertificateDownloading] = useState(false);

  const [CXCUpload, setCXCUpload] = useState(false);
  const [isCXCDownloading, setIsCXCDownloading] = useState(false);

  const [COCUpload, setCOCUpload] = useState(false);
  const [isCOCDownloading, setIsCOCDownloading] = useState(false);

  const [nationalIDUpload, setNationalIDUpload] = useState(false);
  const [isNationalIdDownloading, setIsNationalIdDownloading] = useState(false);

  const [hsDiplomaUpload, setHsDiplomaUpload] = useState(false);
  const [isHsDiplomaDownloading, setIsHsDiplomaDownloading] = useState(false);

  const [policerecordUpload, setPolicerecordUpload] = useState(false);
  const [isPolicerecordDownloading, setIsPolicerecordDownloading] = useState(false);

  const handleDeleteFileClick = (e, type) => {
    e.preventDefault();

    setIsFileModalVisible(true);
    setFileToDelete(type);

    var message = "Are you sure you want to delete file: ";

    if (!props.appObjFiles) {
      if (type === fileTypes.coverletter) {
        message = message + "<strong>" + Auth.candidateCoverLetterFileFriendlyName + "</strong>?";
      } else if (type === fileTypes.resume) {
        message = message + "<strong>" + Auth.candidateResumeFileFriendlyName + "</strong>?";
      } else if (type === fileTypes.birthcertificate) {
        message = message + "<strong>" + Auth.candidateBirtCertificateFriendlyName + "</strong>?";
      } else if (type === fileTypes.cxc) {
        message = message + "<strong>" + Auth.candidateCXCFriendlyName + "</strong>?";
      } else if (type === fileTypes.coc) {
        message = message + "<strong>" + Auth.candidateCOCFileFriendlyName + "</strong>?";
      }
      else if (type === fileTypes.nationalId) {
        message = message + "<strong>" + Auth.candidateNationalIDFileFriendlyName + "</strong>?";
      } else if (type === fileTypes.hsDiploma) {
        message = message + "<strong>" + Auth.candidateHSDiplomaFileFriendlyName + "</strong>?";
      } else if (type === fileTypes.policerecord) {
        message = message + "<strong>" + Auth.candidatePoliceRecordFileFriendlyName + "</strong>?";
      }
    }
    else {
      if (type === fileTypes.coverletter) {
        message = message + "<strong>" + props.appObjFiles.coverLetterFileFriendlyName + "</strong>?";
      } else if (type === fileTypes.resume) {
        message = message + "<strong>" + props.appObjFiles.resumeFileFriendlyName + "</strong>?";
      } else if (type === fileTypes.birthcertificate) {
        message = message + "<strong>" + props.appObjFiles.birthCertFileFriendlyName + "</strong>?";
      } else if (type === fileTypes.cxc) {
        message = message + "<strong>" + props.appObjFiles.cXCFileFriendlyName + "</strong>?";
      } else if (type === fileTypes.coc) {
        message = message + "<strong>" + props.appObjFiles.cOCFileFriendlyName + "</strong>?";
      }
      else if (type === fileTypes.nationalId) {
        message = message + "<strong>" + props.appObjFiles.applicantNationalIDFileFriendlyName + "</strong>?";
      } else if (type === fileTypes.hsDiploma) {
        message = message + "<strong>" + props.appObjFiles.applicantHSDiplomaFileFriendlyName + "</strong>?";
      } else if (type === fileTypes.policerecord) {
        message = message + "<strong>" + props.appObjFiles.applicantPoliceRecordFileFriendlyName + "</strong>?";
      }
    }

    setFileDeleteMessage(message);
  }

  const cancelDeleteFile = () => {
    setIsFileModalVisible(false);
    setFileToDelete("");
  }

  const deleteFile = (e) => {
    e.preventDefault();

    if (props.appObjFiles) {
      if (fileToDelete === fileTypes.coverletter) {
        props.setAppObjFiles({
          ...props.appObjFiles, ...{
            coverLetterFileFriendlyName: null,
            coverLetterUniqueID: null
          }
        })

        setCoverLetterUpload(false);
      }
      else if (fileToDelete === fileTypes.resume) {
        props.setAppObjFiles({
          ...props.appObjFiles, ...{
            resumeFileFriendlyName: null,
            resumeUniqueID: null
          }
        })

        setResumeUpload(false);
      }
      else if (fileToDelete === fileTypes.birthcertificate) {
        props.setAppObjFiles({
          ...props.appObjFiles, ...{
            birthCertFileFriendlyName: null,
            birthCertUniqueID: null
          }
        })
      }
      else if (fileToDelete === fileTypes.cxc) {
        props.setAppObjFiles({
          ...props.appObjFiles, ...{
            cXCFileFriendlyName: null,
            cXCUniqueID: null
          }
        })

        setCXCUpload(false);
      }
      else if (fileToDelete === fileTypes.coc) {
        props.setAppObjFiles({
          ...props.appObjFiles, ...{
            cOCFileFriendlyName: null,
            cOCUniqueID: null
          }
        })

        setCOCUpload(false);
      }
      else if (fileToDelete === fileTypes.nationalId) {
        props.setAppObjFiles({
          ...props.appObjFiles, ...{
            applicantNationalIDUniqueID: null,
            applicantNationalIDFileFriendlyName: null
          }
        })

        setNationalIDUpload(false);
      }
      else if (fileToDelete === fileTypes.hsDiploma) {
        props.setAppObjFiles({
          ...props.appObjFiles, ...{
            applicantHSDiplomaUniqueID: null,
            applicantHSDiplomaFileFriendlyName: null
          }
        })

        setHsDiplomaUpload(false);
      }
      else if (fileToDelete === fileTypes.policerecord) {
        props.setAppObjFiles({
          ...props.appObjFiles, ...{
            applicantPoliceRecordUniqueID: null,
            applicantPoliceRecordFileFriendlyName: null
          }
        })

        setPolicerecordUpload(false);
      }

      setIsFileModalVisible(false);
      return;
    }


    var dispatchPayload = null;
    var formData = null;
    var apiUrl = '';

    if (fileToDelete === fileTypes.coverletter) {
      apiUrl = '/api/candidate/UpdateCandidateCoverLetter';

      formData = {
        CandidateID: Auth.candidateID,
        CandidateCoverLetterUniqueID: "",
        CandidateCoverLetterFileFriendlyName: "",
      };

      dispatchPayload = {
        candidateCoverLetterUniqueID: "",
        candidateCoverLetterFileFriendlyName: "",
      };

    } else if (fileToDelete === fileTypes.resume) {
      apiUrl = '/api/candidate/UpdateCandidateResume';

      formData = {
        CandidateID: Auth.candidateID,
        CandidateResumeUniqueID: "",
        CandidateResumeFileFriendlyName: "",
      };

      dispatchPayload = {
        candidateResumeUniqueID: "",
        candidateResumeFileFriendlyName: "",
      };
    } else {
      if (fileToDelete === fileTypes.birthcertificate) {
        dispatchPayload = {
          candidateBirthCertificateUniqueID: "",
          candidateBirtCertificateFriendlyName: "",
        };
      } else if (fileToDelete === fileTypes.cxc) {
        dispatchPayload = {
          candidateCXCUniqueID: "",
          candidateCXCFriendlyName: "",
        };
      } else if (fileToDelete === fileTypes.coc) {

        dispatchPayload = {
          candidateCOCUniqueID: "",
          candidateCOCFileFriendlyName: "",
        };
      } else if (fileToDelete === fileTypes.nationalId) {
        dispatchPayload = {
          candidateNationalIDFileFriendlyName: "",
          candidateNationalIDUniqueID: "",
        };
      } else if (fileToDelete === fileTypes.hsDiploma) {
        dispatchPayload = {
          candidateHSDiplomaFileFriendlyName: "",
          candidateHSDiplomaUniqueID: "",
        };
      } else if (fileToDelete === fileTypes.policerecord) {
        dispatchPayload = {
          candidatePoliceRecordFileFriendlyName: "",
          candidatePoliceRecordUniqueID: "",
        };
      }
      dispatch(UpdateUser({ ...Auth, ...dispatchPayload }));
      setIsFileModalVisible(false);
      return;
    }

    var jsonStr = JSON.stringify(formData);
    reqPostUpdateCandidateDocs(apiUrl, jsonStr)
      .then(res => {
        if (res.data.isSuccess) {
          MsgBox({
            type: 'success',
            message: 'File Deleted',
            description: 'File Deleted'
          });
        } else {
          MsgBox({
            type: 'error',
            message: 'Error!',
            description: res.data.errorMessage,
          });
        }

        dispatch(UpdateUser({ ...Auth, ...dispatchPayload }));
      })
      .catch(err => {
        MsgBox({
          type: 'error',
          message: 'Error!',
          description: 'Something went wrong while deleting your file.',
        });
        GlobalApiErrorHandler({ errors: err.response.data.errors });
      });

    setIsFileModalVisible(false);
  }

  const handleFileOnChange = (e, fileType) => {
    var files = e.target.files;

    if (files && files.length > 0) {
      uploadFile(files[0], fileTypes[fileType]);
    }

    return;
  }

  const uploadFile = (file, filetype) => {
    const maxAllowedSize = 25 * 1024 * 1024;

    if (file.size > maxAllowedSize) {
      MsgBox({
        type: 'error',
        message: 'Error!',
        description: 'File cannot exceed to 5mb.',
      });
      return;
    }

    if (!acceptedFilesArray.includes(file.type)) {
      MsgBox({
        type: 'error',
        message: 'Error!',
        description: 'File type not supported.',
      });
      return;
    }

    if (filetype === fileTypes.coverletter) {
      setCoverLetterUpload(true);
    } else if (filetype === fileTypes.resume) {
      setResumeUpload(true);
    } else if (filetype === fileTypes.birthcertificate) {
      setBirthcertificateUpload(true);
    } else if (filetype === fileTypes.cxc) {
      setCXCUpload(true);
    } else if (filetype === fileTypes.coc) {
      setCOCUpload(true);
    } else if (filetype === fileTypes.nationalId) {
      setNationalIDUpload(true);
    } else if (filetype === fileTypes.hsDiploma) {
      setHsDiplomaUpload(true);
    } else if (filetype === fileTypes.policerecord) {
      setPolicerecordUpload(true);
    }


    var formData = new FormData();
    formData.append('CountryName', Auth.countryName);
    formData.append('FormFile', file);
    formData.append('metaData', JSON.stringify({
      ContainerName: 'global',
      Type: filetype,
      Country: Auth.countryName,
      CandidateID: Auth.candidateID,
      CandidateEmail: Auth.personalEmail,
      ApplicationID: (!props.appObjFiles ? null : props.appObjFiles.applicationID),
    }));

    var config = {
      onUploadProgress: function (progressEvent) {
        var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        console.log(percentCompleted);
      }
    };

    reqPostUploadFile(formData, config)
      .then(res => {
        if (!props.appObjFiles) {
          saveToProfile(res.data.filename, filetype, file.name);
        }
        else {
          saveToApplication(res.data.filename, filetype, file.name);
        }
      })
      .catch(err => {
        console.log(err);
        MsgBox({
          type: 'error',
          message: 'Error!',
          description: 'Something went wrong while uploading your file.',
        });

        GlobalApiErrorHandler({ errors: err.response.data.errors });

        if (filetype === fileTypes.coverletter) {
          setCoverLetterUpload(false);
        } else if (filetype === fileTypes.resume) {
          setResumeUpload(false);
        } else if (filetype === fileTypes.birthcertificate) {
          setBirthcertificateUpload(false);
        } else if (filetype === fileTypes.cxc) {
          setCXCUpload(false);
        } else if (filetype === fileTypes.coc) {
          setCOCUpload(false);
        } else if (filetype === fileTypes.nationalId) {
          setNationalIDUpload(false);
        } else if (filetype === fileTypes.hsDiploma) {
          setHsDiplomaUpload(false);
        } else if (filetype === fileTypes.policerecord) {
          setPolicerecordUpload(false);
        }
      });

    return;
  }

  const downloadFile = (e, fileType) => {
    e.preventDefault();

    var fileName = "";
    var friendlyFilename = "";

    if (props.appObjFiles) {
      if (fileType === fileTypes.coverletter) {
        fileName = props.appObjFiles.coverLetterUniqueID;
        friendlyFilename = props.appObjFiles.coverLetterFileFriendlyName;
        setIsCoverLetterDownloading(true);
      } else if (fileType === fileTypes.resume) {
        fileName = props.appObjFiles.resumeUniqueID;
        friendlyFilename = props.appObjFiles.resumeFileFriendlyName;
        setIsResumeDownloading(true);
      } else if (fileType === fileTypes.birthcertificate) {
        fileName = props.appObjFiles.birthCertUniqueID;
        friendlyFilename = props.appObjFiles.birthCertFileFriendlyName;
        setIsBirthCertificateDownloading(true);
      } else if (fileType === fileTypes.cxc) {
        fileName = props.appObjFiles.cXCUniqueID;
        friendlyFilename = props.appObjFiles.cXCFileFriendlyName;
        setIsCXCDownloading(true);
      } else if (fileType === fileTypes.coc) {
        fileName = props.appObjFiles.cOCUniqueID;
        friendlyFilename = props.appObjFiles.cOCFileFriendlyName;
        setIsCOCDownloading(true);
      } else if (fileType === fileTypes.nationalId) {
        fileName = props.appObjFiles.applicantNationalIDUniqueID;
        friendlyFilename = props.appObjFiles.applicantNationalIDFileFriendlyName;
        setIsNationalIdDownloading(true);
      } else if (fileType === fileTypes.hsDiploma) {
        fileName = props.appObjFiles.applicantHSDiplomaUniqueID;
        friendlyFilename = props.appObjFiles.applicantHSDiplomaFileFriendlyName;
        setIsHsDiplomaDownloading(true);
      } else if (fileType === fileTypes.policerecord) {
        fileName = props.appObjFiles.applicantPoliceRecordUniqueID;
        friendlyFilename = props.appObjFiles.applicantPoliceRecordFileFriendlyName;
        setIsPolicerecordDownloading(true);
      }
    }
    else {
      if (fileType === fileTypes.coverletter) {
        fileName = Auth.candidateCoverLetterUniqueID;
        friendlyFilename = Auth.candidateCoverLetterFileFriendlyName;
        setIsCoverLetterDownloading(true);
      } else if (fileType === fileTypes.resume) {
        fileName = Auth.candidateResumeUniqueID;
        friendlyFilename = Auth.candidateResumeFileFriendlyName;
        setIsResumeDownloading(true);
      } else if (fileType === fileTypes.birthcertificate) {
        fileName = Auth.candidateBirthCertificateUniqueID;
        friendlyFilename = Auth.candidateBirtCertificateFriendlyName;
        setIsBirthCertificateDownloading(true);
      } else if (fileType === fileTypes.cxc) {
        fileName = Auth.candidateCXCUniqueID;
        friendlyFilename = Auth.candidateCXCFriendlyName;
        setIsCXCDownloading(true);
      } else if (fileType === fileTypes.coc) {
        fileName = Auth.candidateCOCUniqueID;
        friendlyFilename = Auth.candidateCOCFileFriendlyName;
        setIsCOCDownloading(true);
      } else if (fileType === fileTypes.nationalId) {
        fileName = Auth.candidateNationalIDUniqueID;
        friendlyFilename = Auth.candidateNationalIDFileFriendlyName;
        setIsNationalIdDownloading(true);
      } else if (fileType === fileTypes.hsDiploma) {
        fileName = Auth.candidateHSDiplomaUniqueID;
        friendlyFilename = Auth.candidateHSDiplomaFileFriendlyName;
        setIsHsDiplomaDownloading(true);
      } else if (fileType === fileTypes.policerecord) {
        fileName = Auth.candidatePoliceRecordUniqueID;
        friendlyFilename = Auth.candidatePoliceRecordFileFriendlyName;
        setIsPolicerecordDownloading(true);
      }
    }

    var formData = new FormData()
    formData.append('CountryName', Auth.countryName.toLowerCase());
    formData.append('FileName', fileName);
    formData.append('Type', fileType);

    reqPostDownloadFile(formData)
      .then(res => {
        generateDownloadLink(res.data, friendlyFilename, res.headers['content-type'], fileType);
      })
      .catch(err => {
        GlobalApiErrorHandler({ errors: err.response.data.errors });
        console.log(err);
      });

  }
  const generateDownloadLink = (theBlob, fileName, contentType, fileType) => {
    var blob = new Blob([theBlob], { type: contentType });
    var blobUrl = window.URL.createObjectURL(blob);

    console.log(blobUrl);
    const link = document.createElement("a");

    link.href = blobUrl;
    link.download = fileName;

    document.body.appendChild(link);

    link.dispatchEvent(
      new MouseEvent('click', {
        bubbles: true,
        cancelable: true,
        view: window
      })
    );

    setTimeout(() => {
      document.body.removeChild(link);

      if (fileType === fileTypes.coverletter) {
        setIsCoverLetterDownloading(false);
      } else if (fileType === fileTypes.resume) {
        setIsResumeDownloading(false);
      } else if (fileType === fileTypes.birthcertificate) {
        setIsBirthCertificateDownloading(false);
      } else if (fileType === fileTypes.cxc) {
        setIsCXCDownloading(false);
      } else if (fileType === fileTypes.coc) {
        setIsCOCDownloading(false);
      } else if (fileType === fileTypes.nationalId) {
        setIsNationalIdDownloading(false);
      } else if (fileType === fileTypes.hsDiploma) {
        setIsHsDiplomaDownloading(false);
      } else if (fileType === fileTypes.policerecord) {
        setIsPolicerecordDownloading(false);
      }
    }, 200);
  }

  const saveToApplication = (filename, filetype, friendlyName) => {
    if (filetype === fileTypes.coverletter) {
      props.setAppObjFiles({
        ...props.appObjFiles, ...{
          coverLetterFileFriendlyName: friendlyName,
          coverLetterUniqueID: filename
        }
      })
    }
    else if (filetype === fileTypes.resume) {
      props.setAppObjFiles({
        ...props.appObjFiles, ...{
          resumeFileFriendlyName: friendlyName,
          resumeUniqueID: filename
        }
      })
    }
    else if (filetype === fileTypes.birthcertificate) {
      props.setAppObjFiles({
        ...props.appObjFiles, ...{
          birthCertFileFriendlyName: friendlyName,
          birthCertUniqueID: filename
        }
      })
    }
    else if (filetype === fileTypes.cxc) {
      props.setAppObjFiles({
        ...props.appObjFiles, ...{
          cXCFileFriendlyName: friendlyName,
          cXCUniqueID: filename
        }
      })
    }
    else if (filetype === fileTypes.coc) {
      props.setAppObjFiles({
        ...props.appObjFiles, ...{
          cOCFileFriendlyName: friendlyName,
          cOCUniqueID: filename
        }
      })
    }
    else if (filetype === fileTypes.nationalId) {
      props.setAppObjFiles({
        ...props.appObjFiles, ...{
          applicantNationalIDFileFriendlyName: friendlyName,
          applicantNationalIDUniqueID: filename
        }
      })
    }
    else if (filetype === fileTypes.hsDiploma) {
      props.setAppObjFiles({
        ...props.appObjFiles, ...{
          applicantHSDiplomaFileFriendlyName: friendlyName,
          applicantHSDiplomaUniqueID: filename
        }
      })
    }
    else if (filetype === fileTypes.policerecord) {
      props.setAppObjFiles({
        ...props.appObjFiles, ...{
          applicantPoliceRecordFileFriendlyName: friendlyName,
          applicantPoliceRecordUniqueID: filename
        }
      })
    }
  }
  const saveToProfile = (filename, filetype, friendlyName) => {

    var dispatchPayload = null;

    var formData = null;
    var apiUrl = '';

    if (filetype === fileTypes.coverletter) {
      apiUrl = '/api/candidate/UpdateCandidateCoverLetter';

      formData = {
        CandidateID: Auth.candidateID,
        CandidateCoverLetterUniqueID: filename,
        CandidateCoverLetterFileFriendlyName: friendlyName,
      };

      dispatchPayload = {
        candidateCoverLetterUniqueID: filename,
        candidateCoverLetterFileFriendlyName: friendlyName,
      };

    } else if (filetype === fileTypes.resume) {
      apiUrl = '/api/candidate/UpdateCandidateResume';

      formData = {
        CandidateID: Auth.candidateID,
        CandidateResumeUniqueID: filename,
        CandidateResumeFileFriendlyName: friendlyName,
      };

      dispatchPayload = {
        candidateResumeUniqueID: filename,
        candidateResumeFileFriendlyName: friendlyName,
      };
    } else {
      if (filetype === fileTypes.birthcertificate) {
        dispatchPayload = {
          candidateBirthCertificateUniqueID: filename,
          candidateBirtCertificateFriendlyName: friendlyName,
        };
        setBirthcertificateUpload(false);
      } else if (filetype === fileTypes.cxc) {
        dispatchPayload = {
          candidateCXCUniqueID: filename,
          candidateCXCFriendlyName: friendlyName,
        };
        setCXCUpload(false);
      } else if (filetype === fileTypes.coc) {
        dispatchPayload = {
          candidateCOCUniqueID: filename,
          candidateCOCFileFriendlyName: friendlyName,
        };
        setCOCUpload(false);
      } else if (filetype === fileTypes.nationalId) {
        dispatchPayload = {
          candidateNationalIDUniqueID: filename,
          candidateNationalIDFileFriendlyName: friendlyName,
        };
        setNationalIDUpload(false);
      } else if (filetype === fileTypes.hsDiploma) {
        dispatchPayload = {
          candidateHSDiplomaUniqueID: filename,
          candidateHSDiplomaFileFriendlyName: friendlyName,
        };
        setHsDiplomaUpload(false);
      } else if (filetype === fileTypes.policerecord) {
        dispatchPayload = {
          candidatePoliceRecordUniqueID: filename,
          candidatePoliceRecordFileFriendlyName: friendlyName,
        };
        setPolicerecordUpload(false);
      }
      dispatch(UpdateUser({ ...Auth, ...dispatchPayload }));
      return;
    }



    var jsonStr = JSON.stringify(formData);
    reqPostUpdateCandidateDocs(apiUrl, jsonStr)
      .then(res => {
        if (res.data.isSuccess) {
          MsgBox({
            type: 'success',
            message: 'Success!',
            description: 'File Uploaded'
          });
        } else {
          MsgBox({
            type: 'error',
            message: 'Error',
            description: res.data.errorMessage,
          });
        }

        if (filetype === fileTypes.coverletter) {
          setCoverLetterUpload(false);
        } else if (filetype === fileTypes.resume) {
          setResumeUpload(false);
        } else if (filetype === fileTypes.birthcertificate) {
          setBirthcertificateUpload(false);
        }

        dispatch(UpdateUser({ ...Auth, ...dispatchPayload }));
      })
      .catch(err => {
        MsgBox({
          type: 'error',
          message: 'Error!',
          description: 'Something went wrong while uploading your file',
        });

        GlobalApiErrorHandler({ errors: err.response.data.errors });

        if (filetype === fileTypes.coverletter) {
          setCoverLetterUpload(false);
        } else {
          setResumeUpload(false);
        }
      });
  }

  const UploadContent = () => {
    return (
      <>
        <Row>
          <Col xs={24} md={12}>
            <FileUpload
              title="Resume"
              fileType={fileTypes.resume}
              isRequired={props.resumeRequired}
              isDownloading={isResumeDownloading}
              uniqueID={!props.appObjFiles ? Auth.candidateResumeUniqueID : props.appObjFiles.resumeUniqueID}
              friendlyName={!props.appObjFiles ? Auth.candidateResumeFileFriendlyName : props.appObjFiles.resumeFileFriendlyName}
              isfileUpload={resumeUpload}
              handleFileChange={e => handleFileOnChange(e, fileTypes.resume)}
              handleDownloadFile={downloadFile}
              handleDeleteFile={handleDeleteFileClick}
            />
          </Col>
          <Col xs={24} md={12}>
            <FileUpload
              title="Cover Letter"
              fileType={fileTypes.coverletter}
              isRequired={false}
              isDownloading={isCoverLetterDownloading}
              uniqueID={!props.appObjFiles ? Auth.candidateCoverLetterUniqueID : props.appObjFiles.coverLetterUniqueID}
              friendlyName={!props.appObjFiles ? Auth.candidateCoverLetterFileFriendlyName : props.appObjFiles.coverLetterFileFriendlyName}
              isfileUpload={coverLetterUpload}
              handleFileChange={e => handleFileOnChange(e, fileTypes.coverletter)}
              handleDownloadFile={downloadFile}
              handleDeleteFile={handleDeleteFileClick}
            />
          </Col>
        </Row>
        {
          (props.showTTOfiles) && (
            <>
              <Row style={{ display: 'none' }}>
                <Col xs={24} md={12}>
                  <FileUpload
                    title="National ID/Birth Certificate/Passport"
                    fileType={fileTypes.birthcertificate}
                    isRequired={false}
                    isDownloading={isBirthCertificateDownloading}
                    uniqueID={!props.appObjFiles ? Auth.candidateBirthCertificateUniqueID : props.appObjFiles.birthCertUniqueID}
                    friendlyName={!props.appObjFiles ? Auth.candidateBirtCertificateFriendlyName : props.appObjFiles.birthCertFileFriendlyName}
                    isfileUpload={birthCertificateUpload}
                    handleFileChange={e => handleFileOnChange(e, fileTypes.birthcertificate)}
                    handleDownloadFile={downloadFile}
                    handleDeleteFile={handleDeleteFileClick}
                  />
                </Col>
                <Col xs={24} md={12}>
                  <FileUpload
                    title="CXC Qualification"
                    fileType={fileTypes.cxc}
                    isRequired={false}
                    isDownloading={isCXCDownloading}
                    uniqueID={!props.appObjFiles ? Auth.candidateCXCUniqueID : props.appObjFiles.cXCUniqueID}
                    friendlyName={!props.appObjFiles ? Auth.candidateCXCFriendlyName : props.appObjFiles.cXCFileFriendlyName}
                    isfileUpload={CXCUpload}
                    handleFileChange={e => handleFileOnChange(e, fileTypes.cxc)}
                    handleDownloadFile={downloadFile}
                    handleDeleteFile={handleDeleteFileClick}
                  />
                </Col>
              </Row>
              <Row style={{ display: 'none' }}>
                <Col xs={24} md={12}>
                  <FileUpload
                    title="Certificate of Character/ Fingerprinting Receipt/Proof of appointment"
                    titleStyle={{
                      display: 'inline-block',
                      marginRight: '4px',
                      fontSize: '14px',
                      fontWeight: '700',
                      lineHeight: 1,
                    }}
                    desc={
                      <>
                        <label
                          style={{
                            display: 'inline-block',
                            marginRight: '4px',
                            fontSize: '12px',
                            lineHeight: 1,
                          }}
                        >
                          Note: If a COC is not available then proof of appointment or COC receipt is required. Please visit the Ministry of National Security’s website to apply for the COC
                        </label>
                      </>
                    }
                    fileType={fileTypes.coc}
                    isRequired={false}
                    isDownloading={isCOCDownloading}
                    uniqueID={!props.appObjFiles ? Auth.candidateCOCUniqueID : props.appObjFiles.cOCUniqueID}
                    friendlyName={!props.appObjFiles ? Auth.candidateCOCFileFriendlyName : props.appObjFiles.cOCFileFriendlyName}
                    isfileUpload={COCUpload}
                    handleFileChange={e => handleFileOnChange(e, fileTypes.coc)}
                    handleDownloadFile={downloadFile}
                    handleDeleteFile={handleDeleteFileClick}
                  />
                </Col>
              </Row>
            </>
          )
        }
        {
          (props.showPANfiles) && (
            <>
              <Row style={{ display: 'none' }}>
                <Col xs={24} md={12}>
                  <FileUpload
                    title="National ID/Passport"
                    fileType={fileTypes.nationalId}
                    isRequired={false}
                    isDownloading={isNationalIdDownloading}
                    uniqueID={!props.appObjFiles ? Auth.candidateNationalIDUniqueID : props.appObjFiles.applicantNationalIDUniqueID}
                    friendlyName={!props.appObjFiles ? Auth.candidateNationalIDFileFriendlyName : props.appObjFiles.applicantNationalIDFileFriendlyName}
                    isfileUpload={nationalIDUpload}
                    handleFileChange={e => handleFileOnChange(e, fileTypes.nationalId)}
                    handleDownloadFile={downloadFile}
                    handleDeleteFile={handleDeleteFileClick}
                  />
                </Col>
                <Col xs={24} md={12}>
                  <FileUpload
                    title="High School Diploma or Highest Educational Attainment "
                    fileType={fileTypes.hsDiploma}
                    isRequired={false}
                    isDownloading={isHsDiplomaDownloading}
                    uniqueID={!props.appObjFiles ? Auth.candidateHSDiplomaUniqueID : props.appObjFiles.applicantHSDiplomaUniqueID}
                    friendlyName={!props.appObjFiles ? Auth.candidateHSDiplomaFileFriendlyName : props.appObjFiles.applicantHSDiplomaFileFriendlyName}
                    isfileUpload={hsDiplomaUpload}
                    handleFileChange={e => handleFileOnChange(e, fileTypes.hsDiploma)}
                    handleDownloadFile={downloadFile}
                    handleDeleteFile={handleDeleteFileClick}
                  />
                </Col>
              </Row>
              <Row style={{ display: 'none' }}>
                <Col xs={24} md={12}>
                  <FileUpload
                    title="Valid Police Record"
                    fileType={fileTypes.policerecord}
                    isRequired={false}
                    isDownloading={isPolicerecordDownloading}
                    uniqueID={!props.appObjFiles ? Auth.candidatePoliceRecordUniqueID : props.appObjFiles.applicantPoliceRecordUniqueID}
                    friendlyName={!props.appObjFiles ? Auth.candidatePoliceRecordFileFriendlyName : props.appObjFiles.applicantPoliceRecordFileFriendlyName}
                    isfileUpload={policerecordUpload}
                    handleFileChange={e => handleFileOnChange(e, fileTypes.policerecord)}
                    handleDownloadFile={downloadFile}
                    handleDeleteFile={handleDeleteFileClick}
                  />
                </Col>
              </Row>
            </>
          )
        }
      </>
    )
  }

  return (
    <>
      <Row justify="center">
        <Col sm={23} xs={24}>
          <Card title="Documents" className="documents-card iqor-header">
            {
              (props.isProfileLoading) ? (
                <Skeleton active />
              ) : (
                <>
                  <Row>
                    <Col xs={24} md={24}>
                      <p>
                        <strong>Accepted file types:</strong> DOCX, PDF and Image (MSG, PPT, XLS and TXT file types are not accepted)
                      </p>
                    </Col>
                  </Row>
                  <UploadContent />
                </>
              )
            }
          </Card>
        </Col>
      </Row>

      <CustomAlertModal
        type="confirm"
        content={fileDeleteMessage}
        onCancel={() => { cancelDeleteFile() }}
        visible={isFileModalVisible}
        destroyOnClose={true}
        footer={[
          <Button
            key='yes'
            onClick={(e) => { deleteFile(e) }}
            type="danger"
          >
            Yes
          </Button>,
          <Button
            key='no'
            onClick={e => { e.preventDefault(); cancelDeleteFile(); }}
            type="danger"
          >
            No
          </Button>
        ]}
      />
    </>
  );
}
